import { useContext } from 'react';

import { AuthContext } from 'contexts/authContext';
import type { AuthContextType } from 'contexts/authContext';

export function useAuth(): AuthContextType {
  const auth = useContext(AuthContext);
  return auth;
}
